/**
 * description:
 * dateTime: 2024/8/20-下午5:51
 * author: ZhangJun 1580043700@qq.com
 */
import {SFuncModal} from "shj-components";
import {Form, Input, Select} from "antd";
import {useEffect} from "react";
import {useRequest} from "ahooks";
import {queryMemberEquityCategoryList, saveOrUpdateMemberEquityCategory} from "@/services/member.ts";

type EditOption = {
    title: string,
    data?: any
    options?: Array<any>
    destroy: (success: boolean) => void
}

export function openEdit(option: EditOption) {
    const destroy = (success: boolean) => {
        modal.destroy();
        option.destroy(success);
    }
    const modal = SFuncModal({
        content: (<EditContent destroy={destroy} data={option.data} options={option.options}/>),
        title: option.title,
        vanish: true,
    });
}

function EditContent(props) {

    const [form] = Form.useForm();
    const {loading, runAsync} = useRequest(saveOrUpdateMemberEquityCategory, {manual: true});
    const {
        loading: memberLoading,
        data: memberEquityCategoryList
    }: any = useRequest(queryMemberEquityCategoryList, {defaultParams: [{data: {}}]});

    useEffect(() => {
        form.resetFields();
        form.setFieldsValue(props.data);
    }, [props.data])

    const onOk = () => {
        form.validateFields().then(values => {
            runAsync({...props.data, ...values}).then(() => {
                props.destroy(true);
            })
        })
    }
    console.log('props.options', props.options)

    return (
        <SFuncModal.Content onOk={onOk} onCancel={() => props.destroy(false)} confirmLoading={loading}>
            <Form form={form} layout='vertical'>
                {
                    props?.data?.parentId && (
                        <Form.Item label='父级分类' name='parentId'>
                            <Select options={memberEquityCategoryList || []}
                                    fieldNames={{label: 'name', value: 'id'}}
                                    loading={memberLoading}></Select>
                        </Form.Item>
                    )
                }
                <Form.Item label='分类名称' name='name' rules={[{required: true}]}>
                    <Input maxLength={20}/>
                </Form.Item>
            </Form>
        </SFuncModal.Content>
    )
}

